import * as ActionTypes from 'modules/lockers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [ActionTypes.GET_LOCKERS_REQUEST]: isLoading,
  [ActionTypes.GET_LOCKERS_SUCCESS]: isEnding,
  [ActionTypes.GET_LOCKERS_FAILURE]: isEnding,
});
